import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getAvailableSlashCommandsQueryKey = () => QueryClientHelper.makeQueryKey('/rest/commands/available');
//# sourceMappingURL=commandsKeys.js.map